export const isOnboardedCandidate = user =>
  user.on_boarded && user.user_type === "candidate";

export const isInsider = user =>
  user.user_type === "insider" && user.on_boarded;

export const getUserData = user => ({
  first_name: user.first_name,
  last_name: user.last_name,
  timezone: user.timezone,
  phone: user.phone,
  avatar: user.photo,
  send_sms_notifications: user.send_sms_notifications
});



// WEBPACK FOOTER //
// ./src/modules/user/auth/model.js